import styled, { css } from "styled-components";

import { windowWidth } from "@styles/global";

interface ContainerProps {
  showBorderBottom: boolean;
}

const Container = styled.div<ContainerProps>`
  width: 100%;
  padding-top: 4px;
  margin-bottom: -2px;

  .MuiAutocomplete-root {
    width: 100%;

    ${({ showBorderBottom }) => !showBorderBottom
      && css`
        .MuiInput-root {
          &::before {
            border-bottom: none;
          }
        }
      `}
  }
`;

export { Container };
